// endpoints
import * as carEndPoints from "../constants/endpoints/car";
// axios
import axios from "../axios/axios";

export const getAllCarBrandsInInventoryForSalesWebsite = () => {
  return axios({
    url: carEndPoints.getAllCarBrandsInInventoryForSalesWebsite,
    method: "GET",
  });
};

export const getAllCarModelsInInventoryGivenCarBrandId = (carBrandId) => {
  return axios({
    url: carEndPoints.getAllCarModelsInInventoryGivenCarBrandId.replace(
      ":carBrandId",
      carBrandId
    ),
    method: "GET",
  });
};

export const getAllCarsInInventoryGivenCarModelId = (carModelId) => {
  return axios({
    url: carEndPoints.getAllCarsInInventoryGivenCarModelId.replace(
      ":carModelId",
      carModelId
    ),
    method: "GET",
  });
};

export const getBrandFamilies = (params) => {
  return axios({
    url: carEndPoints.getBrandFamilies,
    method: "GET",
    params,
  });
};

export const getAllActiveCarBrands = (params) => {
  return axios({
    url: carEndPoints.getAllActiveCarBrands,
    method: "GET",
    params,
  });
};

export const getCarModels = (params) => {
  return axios({
    url: carEndPoints.getCarModels,
    method: "GET",
    params,
  });
};
